import { render } from "./ToolbarGroup.vue?vue&type=template&id=06a6e9ce"
import script from "./ToolbarGroup.vue?vue&type=script&lang=js"
export * from "./ToolbarGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Toolbar/ToolbarGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06a6e9ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06a6e9ce', __exports__)) {
    console.log('reload')
    api.reload('06a6e9ce', __exports__)
  }
  
  module.hot.accept("./ToolbarGroup.vue?vue&type=template&id=06a6e9ce", () => {
    console.log('re-render')
    api.rerender('06a6e9ce', render)
  })

}


export default __exports__